import {z} from 'zod';

const CLIPBOARD_KEY = 'banani-screen-clipboard';

const clipboardNodeSizeSchema = z.object({
  width: z.number(),
  height: z.number(),
});

const clipboardSchema = z.object({
  version: z.literal(2),
  timestamp: z.number(),
  sourceFlowId: z.string(),
  screenIds: z.array(z.string()),
  nodeSizes: z.record(z.string(), clipboardNodeSizeSchema),
});

export type ClipboardNodeSize = z.infer<typeof clipboardNodeSizeSchema>;
export type ClipboardData = z.infer<typeof clipboardSchema>;

export function saveClipboard(data: ClipboardData): void {
  try {
    localStorage.setItem(CLIPBOARD_KEY, JSON.stringify(data));
  } catch {
    // Ignore storage failures (quota, private mode).
  }
}

export function getClipboard(): ClipboardData | null {
  try {
    const raw = localStorage.getItem(CLIPBOARD_KEY);
    if (!raw) return null;

    const parsed = clipboardSchema.safeParse(JSON.parse(raw));
    if (!parsed.success) return null;

    return parsed.data;
  } catch {
    return null;
  }
}
